import React from "react";
import OverviewCard from "../../../../components/cards/OverviewCard";
import { useAppSelector } from "../../../../redux/app/hooks";

const ReferralsSummary = () => {
  const { ReferredUsers, isLoading } = useAppSelector((state) => state.admin);
  const totals = ReferredUsers?.data?.totals;

  return (
    // <WhiteTitledCard>
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-6 bg-white rounded-lg p-2">
      <OverviewCard
        title="Total Referrals"
        value={totals?.totalReferrals || 0}
        iconBg="bg-bgRed"
        isLoading={isLoading}
        className="border-0 border-r rounded-none border-gray-300"
      />
      <OverviewCard
        title="Active Referrals"
        value={totals?.activeReferrals || 0}
        iconBg="bg-bgBlue"
        isLoading={isLoading}
        className="border-0 border-r rounded-none border-gray-300"
      />
      <OverviewCard
        title="Inactive Referrals"
        value={totals?.inactiveReferrals || 0}
        iconBg="bg-bgPurple"
        isLoading={isLoading}
        className="border-0 border-r rounded-none border-gray-300"
      />
      <OverviewCard
        title="Referrals with purchases"
        value={totals?.totalPurchasesFromReferrals || 0}
        iconBg="bg-bgBlack"
        isLoading={isLoading}
        className="border-0 border-r rounded-none border-gray-300"
      />
    </div>
    // </WhiteTitledCard>
  );
};

export default ReferralsSummary;
